export default __webpack_public_path__ + "static/fonts/Everett-Bold.a30612d.woff2";